import { IHoliday } from '@vacationtracker/shared/types/holidays'
import { LocaleEnum } from '@vacationtracker/shared/types/i18n'
import { ILeaveDayDetails, IPartDay, LeaveRequestStatus } from '@vacationtracker/shared/types/leave-request'
import { IGetUserIdsForApproverTo } from '../../types/custom-queries'
import { IHeatMapLeaves } from '../../types/dashboard'
import { WorkingHours } from '@vacationtracker/shared/types/work-week'

export interface IHeatmapChartProps {
  month: number
  year: number
  onPreviousMonth: () => void
  onNextMonth: () => void
  workingDays: number[]
  holidays: IHeatmapHoliday[]
  leaves: IHeatMapLeaves[]
  isHeatmapLoading: boolean
  hourlyLeaveAccounting: boolean
  role: string
  onCancelLeave: (e) => void
  approverToUsers: IGetUserIdsForApproverTo[]
  locale?: LocaleEnum
  // Set of leave IDs that have been locally cancelled - used to filter out leaves
  // that may still appear as APPROVED due to eventual consistency race conditions
  cancelledLeaveIds?: Set<string>
  managedLocationIds?: string[]
  greyOutWhenNotLinkable?: boolean
}

export interface IHeatmapChartMonthProps {
  month: number
  year: number
  workingDays: number[]
  data: HeatmapEntry[][]
  onSelect: (day: number) => void
}

export interface IHeatmapData {
  data: number[]
  label: string
  backgroundColor: string
}

export enum HeatmapEventType {
  holiday = 'holiday',
  leave = 'leave',
}

export interface IHeatmapHoliday extends IHoliday {
  heatmapType: HeatmapEventType.holiday
  locationName: string
  locationId: string
}

export interface IHeatmapLeave {
  heatmapType: HeatmapEventType.leave
  name: string
  color: string
  userName: string
  userId: string
  userImage: string
  userWorkHours?: WorkingHours
  approversName: string[]
  autoApproved: boolean
  daysList: ILeaveDayDetails[]
  partDay?: IPartDay
  partDayStartHour?: number
  partDayEndHour?: number
  reason: string
  id: string
  startDate: string
  endDate: string
  isPartDay: boolean
  status: LeaveRequestStatus
  workingDays: number
  hasWorkingHoursSchedule?: boolean
  hideLeaveType?: boolean
  approvedBySubstituteApprover?: boolean
  substituteApproverId?: boolean
  userLocationId?: string
}

export type HeatmapEntry = IHeatmapHoliday | IHeatmapLeave

export interface IDaysData {
  [day: number]: HeatmapEntry[]
}
